/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Eye = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 20 12">
      <g>
        <path d="M10,8.5 C8.61928813,8.5 7.5,7.38071187 7.5,6 C7.5,4.61928813 8.61928813,3.5 10,3.5 C11.3807119,3.5 12.5,4.61928813 12.5,6 C12.5,6.66304122 12.2366079,7.29892601 11.767767,7.76776695 C11.298926,8.2366079 10.6630412,8.5 10,8.5 Z M10,4.5 C9.17157288,4.5 8.5,5.17157288 8.5,6 C8.5,6.82842712 9.17157288,7.5 10,7.5 C10.8284271,7.5 11.5,6.82842712 11.5,6 C11.5,5.17157288 10.8284271,4.5 10,4.5 Z" />
        <path d="M10.48,11.5 L9.48,11.5 C5.83536448,11.3210282 2.50995341,9.36688212 0.58,6.27 C0.469150262,6.1070662 0.469150262,5.8929338 0.58,5.73 C2.54330709,2.64810572 5.87141192,0.70112717 9.52,0.5 L10.52,0.5 C14.1610333,0.682183036 17.4820329,2.63593194 19.41,5.73 C19.5208497,5.8929338 19.5208497,6.1070662 19.41,6.27 C17.448717,9.34912637 14.1249858,11.2957237 10.48,11.5 Z M1.6,6 C3.38878503,8.63362944 6.29298668,10.2942276 9.47,10.5 L10.47,10.5 C13.6589458,10.2800902 16.5757921,8.62488111 18.4,6 C16.611215,3.36637056 13.7070133,1.70577242 10.53,1.5 L9.53,1.5 C6.34105422,1.71990978 3.42420794,3.37511889 1.6,6 Z" />
      </g>
    </BaseSvgIcon>
  )
}

export default Eye
